import { render, staticRenderFns } from "./TinyCardView.vue?vue&type=template&id=c76e7d3c&scoped=true"
import script from "./TinyCardView.vue?vue&type=script&lang=js"
export * from "./TinyCardView.vue?vue&type=script&lang=js"
import style0 from "./TinyCardView.vue?vue&type=style&index=0&id=c76e7d3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c76e7d3c",
  null
  
)

export default component.exports